import { Storage } from 'aws-amplify';
import { Fragment, useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';

const FileUploader = ({ getFileInfo, fileLink }) => {
    const [fileName, setFileName] = useState('')
    const [uploadProgress, setUploadProgress] = useState('')

    useEffect(() => {
        if (fileLink) {
            const setImageNameState = () => {
                let outputString = fileLink.split('-hrcas3-');
                let splitFileName = outputString[1]
                setFileName(splitFileName)
            }
            
            setImageNameState()
        }
    }, [fileLink])

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    function getFileType(fileType) {
        if (fileType.match('image.*'))
            return 'image'

        if (fileType.match('video.*'))
            return 'video'

        if (fileType.match('audio.*'))
            return 'audio'

        if (fileType.match('application.*'))
            return 'document'
    }

    async function onChange(e) {
        const file = e.target.files[0]

        try {
            // Set the file name beside the custom upload button if uploaded
            setFileName(file.name)

            // Upload the file selected
            const uuidFileName = uuidv4() + '-hrcas3-' + file.name
            await Storage.put(uuidFileName, file, {
                progressCallback(progress) {
                    const loaded =  progress.loaded
                    const total = progress.total
                    let percent = Math.floor((loaded*100)/total)

                    if (percent < 100) {
                        setUploadProgress(percent)
                    } else if (percent === 100) {
                        setUploadProgress(100)
                        setTimeout(() => {
                            setUploadProgress('')
                        }, 1000)
                    }
                }
            })

            getFileInfo((file.name).replace(/\.[^/.]+$/, ""), uuidFileName, getFileType(file.type), formatBytes(file.size))

            if (fileLink) {
                setFileName(file.name)
            }
        } catch(err) {
            console.log(err)
        }
    }

    return (
        <div>
            { fileName ?
                <Fragment>
                    <label className='btn btn-primary' style={{ width: '10rem', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        onChange={onChange}
                        style={{ display: 'none', width: '105px', color: 'transparent'}}
                        id='file'
                    />
                    </label>
                    {
                        fileName && 
                        <label htmlFor='file' style={{display: 'inline-block'}}>{fileName}</label>
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
                :
                <Fragment>
                    <label className='btn btn-primary' style={{ width: '10rem', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        onChange={onChange}
                        style={{ display: 'none' }}
                        id='file'
                    />
                    </label>
                    {
                        fileName ?
                        <label htmlFor='file' style={{display: 'unset'}}>
                            {fileName}
                        </label>
                        :
                        'No file chosen'
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
            }
        </div>
    )
}

export default FileUploader
